import { ReduxState } from "Store/rootReducer";
import { useSelector } from "react-redux";
import { AkaHealthConfig } from "./akaHealthConfigInterfaces";

export const useAkaHealthConficSelector = (): AkaHealthConfig | null =>
  useSelector((state: ReduxState) => state.akaHealthConfig.current);
